module.exports = __WEBPACK_EXTERNAL_MODULE_32__;


//////////////////
// WEBPACK FOOTER
// external "oasi-bpm-history"
// module id = 32
// module chunks = 0